module.exports = __webpack_public_path__ + "img/prof1.a60cf608.jpg";